var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvisibility(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44872 0.751466C3.98009 0.282837 3.2203 0.282837 2.75167 0.751466C2.28304 1.22009 2.28304 1.97989 2.75167 2.44852L19.5517 19.2485C20.0203 19.7172 20.7801 19.7172 21.2487 19.2485C21.7174 18.7799 21.7174 18.0201 21.2487 17.5515L19.4809 15.7837C21.326 14.3109 22.727 12.3053 23.4511 9.99995C21.9219 5.13145 17.3736 1.59999 12.0005 1.59999C10.0522 1.59999 8.21233 2.0643 6.58554 2.88828L4.44872 0.751466ZM9.56195 5.86469L11.3786 7.68135C11.577 7.62829 11.7854 7.59999 12.0005 7.59999C13.326 7.59999 14.4005 8.67451 14.4005 9.99999C14.4005 10.2151 14.3722 10.4235 14.3191 10.6219L16.1358 12.4385C16.5581 11.7239 16.8005 10.8902 16.8005 9.99999C16.8005 7.34903 14.6515 5.19999 12.0005 5.19999C11.1102 5.19999 10.2766 5.44235 9.56195 5.86469Z",
    fill: "#636364"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9451 18.036L11.6998 14.7907C9.28835 14.6417 7.35883 12.7121 7.20977 10.3007L2.8021 5.89305C1.80095 7.08667 1.02784 8.47802 0.549805 10C2.07894 14.8685 6.62727 18.4 12.0004 18.4C13.0164 18.4 14.0029 18.2737 14.9451 18.036Z",
    fill: "#636364"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisibility);
export default __webpack_public_path__ + "static/media/invisibility.4e4e913e.svg";
export { ForwardRef as ReactComponent };